import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  where,
} from 'firebase/firestore';
import { db } from './firebase';

export type Row = { id: string } & Record<string, unknown>;

/** List a collection (optionally ordered by a field, desc). */
export async function listCollection(name: string, orderField?: string): Promise<Row[]> {
  const ref = collection(db, name);
  const snap = await getDocs(orderField ? query(ref, orderBy(orderField, 'desc')) : ref);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }) as Row);
}

export async function getRow(name: string, id: string): Promise<Row | null> {
  const snap = await getDoc(doc(db, name, id));
  return snap.exists() ? ({ id: snap.id, ...snap.data() } as Row) : null;
}

export async function getRowBy(name: string, field: string, value: string): Promise<Row | null> {
  const snap = await getDocs(query(collection(db, name), where(field, '==', value), limit(1)));
  const d = snap.docs[0];
  return d ? ({ id: d.id, ...d.data() } as Row) : null;
}

/** Create/update. When `id` is omitted a new doc id is generated. */
export async function saveRow(
  name: string,
  id: string | undefined,
  data: Record<string, unknown>,
): Promise<string> {
  const ref = id ? doc(db, name, id) : doc(collection(db, name));
  const exists = id ? (await getDoc(ref)).exists() : false;
  await setDoc(
    ref,
    {
      ...(exists ? {} : { createdAt: serverTimestamp() }),
      ...data,
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
  return ref.id;
}

export async function deleteRow(name: string, id: string): Promise<void> {
  await deleteDoc(doc(db, name, id));
}
